export default "__VITE_ASSET__2a824LKk__"